import classNames from 'classnames';
import { Button } from '@medifind/shared-basic-components';
import styles from './AccordionSection.module.scss';

const AccordionSectionTab = ({ text, isActive, onClick, classes = {} }) => {
  return (
    <div
      className={classNames(
        styles['section-accordion__tab'],
        {
          [styles['active-tab']]: isActive,
        },
        classes.accordianTab,
        isActive && classes.accordianTabActive,
      )}
      onClick={onClick}
    >
      <Button noPadding label={text} />
    </div>
  );
};

export { AccordionSectionTab as default, AccordionSectionTab };
